export default "__VITE_PUBLIC_ASSET__fef83128__"